import React, {ReactElement, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {hideEstimateFileEdiUploadModal} from "@estimate/store/estimateSlice";
import {AppDispatch} from "@src/store";
import {Button, Form, Modal} from "react-bootstrap";
import {estimateState, refreshEstimate} from "@estimate/store/estimateSlice";
import {FormError} from "@src/components";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCloudUpload, faSpinner} from "@fortawesome/pro-regular-svg-icons";
import {EstimateFileEdiImportFormErrorType, EstimateType} from "@estimate/types/estimate.types";
import {Maybe} from "@src/types/global.types";
import {toast} from "react-toastify";
import {importEstimateEdiFile} from "@estimate/utils/axios";

interface EstimateItemEdiUploadProps {
}

const EstimateItemEdiUploadModal: React.FC<EstimateItemEdiUploadProps> = (): ReactElement => {

    const estimate: Maybe<EstimateType> = useSelector(estimateState).estimate;
    const [formErrors, setFormErrors] = useState<EstimateFileEdiImportFormErrorType>({});
    const [selectedFile, setSelectedFile] = React.useState<Maybe<any>>();
    const [isUploadingFiles, setUploadingFiles] = React.useState<boolean>(false);
    const isShowEstimateFileEdiUploadModal: boolean = useSelector(estimateState).isShowEstimateFileEdiUploadModal;
    const dispatch = useDispatch<AppDispatch>();

    const onFileChangeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
        setSelectedFile(e.target.files);
    }

    const onSubmitHandler = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        if (!selectedFile || isUploadingFiles) {
            return;
        }

        const eventCurrentTarget = event.currentTarget;
        const formData: FormData = new FormData(eventCurrentTarget);

        setUploadingFiles(true);
        importEstimateEdiFile(estimate.id, formData)
            .then(() => {
                toast.success("Zapisano");
                eventCurrentTarget.reset();
                dispatch(hideEstimateFileEdiUploadModal());
                dispatch(refreshEstimate());
            })
            .catch(error => {
                if (400 === error.response.status) {
                    const responseErrors = error.response?.data?.errors || {};
                    setFormErrors(responseErrors);
                } else {
                    console.log('Error', error.message);
                }
            })
            .finally(() => {
                setUploadingFiles(false);
            });
    }

    return (
        <>
            <Modal show={isShowEstimateFileEdiUploadModal} onHide={() => dispatch(hideEstimateFileEdiUploadModal())}
                   size={"lg"} centered={true}
                   className="modal-blur"
            >
                <Modal.Header closeButton>
                    <Modal.Title as="h5">Import kosztorysu z pliku EDI</Modal.Title>
                </Modal.Header>
                <Modal.Body>

                    <Form onSubmit={onSubmitHandler}>
                        <Form.Group className="mb-3">
                            <Form.Label column className="required">Plik EDI:</Form.Label>
                            <Form.Control
                                placeholder="Wybierz plik" name="file" type={"file"} multiple={false}
                                onChange={onFileChangeHandler}
                                isInvalid={!!formErrors.file}
                            />
                            <FormError errors={formErrors.file}/>
                        </Form.Group>

                        <Button type="submit" variant="primary" disabled={!selectedFile || isUploadingFiles}>
                            {isUploadingFiles ? (
                                <><FontAwesomeIcon icon={faSpinner} spin fixedWidth/>&nbsp;Wysyłam</>
                            ) : (
                                <><FontAwesomeIcon icon={faCloudUpload} fixedWidth/>&nbsp;Wyślij</>
                            )}
                        </Button>
                    </Form>

                </Modal.Body>
            </Modal>
        </>
    );
}

export default EstimateItemEdiUploadModal;